import { TARGET_ALL } from 'entities/user_notice/constants/target_type'
import {
  SET_PARAM_KEY,
  SET_RECRUITER_DESTINATION_CANDIDATE_TARGET,
  SET_TAG_DESTINATION_CANDIDATE_TARGET
} from '../constants/action_types'

const initialState = {
  paramKey: null,
  recruiterDestinationCandidateTarget: TARGET_ALL,
  tagDestinationCandidateTarget: TARGET_ALL
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_PARAM_KEY:
      return {
        ...state,
        paramKey: action.payload.paramKey
      }
    case SET_RECRUITER_DESTINATION_CANDIDATE_TARGET:
      return {
        ...state,
        recruiterDestinationCandidateTarget: action.payload.target
      }
    case SET_TAG_DESTINATION_CANDIDATE_TARGET:
      return {
        ...state,
        tagDestinationCandidateTarget: action.payload.target
      }
    default:
      return state
  }
}
